const DEFAULT_DEV_DATA_BASE_URL = '/dev-data';
const DEFAULT_DEV_SEC_SOURCE_BASE_URL = '/dev-sec-source';
const DEFAULT_FIXTURE_DATA_BASE_URL = '/fixtures';

export const DATA_MODES = {
  LOCAL: 'local',
  FIXTURE: 'fixture',
  PRODUCTION: 'production',
};

export const getDataMode = () => {
  const configured = process.env.REACT_APP_DATA_MODE;
  if (configured) return configured;
  return process.env.NODE_ENV === 'development' ? DATA_MODES.LOCAL : DATA_MODES.PRODUCTION;
};

export const shouldUseLocalOrFixtureData = () => {
  const mode = getDataMode();
  return mode === DATA_MODES.LOCAL || mode === DATA_MODES.FIXTURE;
};

const joinUrl = (baseUrl, relativePath) => {
  const cleanBase = String(baseUrl || '').replace(/\/+$/, '');
  const cleanPath = String(relativePath || '').replace(/^\/+/, '');
  return `${cleanBase}/${cleanPath}`;
};

export const fetchJson = async (url, label = url) => {
  const response = await fetch(url, { credentials: 'same-origin' });
  if (!response.ok) {
    throw new Error(`Failed to load ${label}: ${response.status}`);
  }
  return response.json();
};

export const getDevDataUrl = (relativePath) => (
  joinUrl(process.env.REACT_APP_DEV_DATA_URL || DEFAULT_DEV_DATA_BASE_URL, relativePath)
);

export const getDevSecSourceUrl = (relativePath) => (
  joinUrl(
    process.env.REACT_APP_DEV_SEC_SOURCE_URL || DEFAULT_DEV_SEC_SOURCE_BASE_URL,
    relativePath,
  )
);

export const getFixtureDataUrl = (relativePath) => (
  joinUrl(process.env.REACT_APP_FIXTURE_DATA_URL || DEFAULT_FIXTURE_DATA_BASE_URL, relativePath)
);

export const loadDevJson = (relativePath) => (
  fetchJson(getDevDataUrl(relativePath), relativePath)
);

export const loadFixtureJson = (relativePath) => (
  fetchJson(getFixtureDataUrl(relativePath), relativePath)
);

export const loadLocalOrFixtureJson = (relativePath) => {
  if (getDataMode() === DATA_MODES.FIXTURE) {
    return loadFixtureJson(relativePath);
  }
  return loadDevJson(relativePath);
};
